/**
 * An order's or a purchase order's Needs attention, on its own page (v1
 * completion I §10, the mock-up's state 8): the strip under the header, and the
 * alert's sheet when a chip is opened. `useSubjectAlerts` reads them; a line's
 * own chips come from the same read (`lineChips`).
 */
import { useState } from "react";
import type { NeedsAttentionItem } from "@shared-core/data/needs-attention-types";
import { SlideOverPanel } from "../../patterns/SlideOverPanel";
import { AlertChips } from "./AlertChips";
import { AlertSheet } from "./AlertSheet";

export interface SubjectAlertsProps {
  alerts: NeedsAttentionItem[];
  /** The page's own number: chips on it say only their rule. */
  subjectRef: string;
  onChanged: () => void;
}

/** The strip, and the sheet a chip opens. Use `useAlertSheet` to open it from a line's chip too. */
export function SubjectAlerts({
  alerts,
  subjectRef,
  onChanged,
  openAlertId,
  onOpen,
}: SubjectAlertsProps & AlertSheetState) {
  const open = alerts.find((a) => a.id === openAlertId);
  return (
    <>
      <AlertChips alerts={alerts} subjectRef={subjectRef} onOpen={onOpen} />
      <SlideOverPanel
        open={Boolean(openAlertId)}
        onOpenChange={(isOpen) => !isOpen && onOpen(null)}
        title={open?.headline ?? "Alert"}
        className="w-full sm:max-w-md"
      >
        {openAlertId && (
          <AlertSheet alertId={openAlertId} onChanged={onChanged} />
        )}
      </SlideOverPanel>
    </>
  );
}

export interface AlertSheetState {
  openAlertId: string | null;
  onOpen: (alertId: string | null) => void;
}

/** Which alert's sheet is open on the page: the strip's chips and a line's share it. */
export function useAlertSheet(): AlertSheetState {
  const [openAlertId, setOpenAlertId] = useState<string | null>(null);
  return { openAlertId, onOpen: setOpenAlertId };
}
